import { render, staticRenderFns } from "./ResourcesIndexParent.vue?vue&type=template&id=ef7b2318"
import script from "./ResourcesIndexParent.vue?vue&type=script&lang=js"
export * from "./ResourcesIndexParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports